const mediaQueries = {
  xs: '0px',
  sm: '430px',
  md: '744px',
  lg: '1024px',
  xl: '1280px',
};

export default mediaQueries;
